<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_hr']==1">  

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-leave size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Staff Time Off</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(schoolterm)="data">
                {{ data.item.schoolterm.name }}
              </template>
              <template #cell(staffmember)="data">
                {{ data.item.staffmember.full_name }} <br>
                <small><b>{{ data.item.staffmember.contact }}</b></small>
              </template>
              <template #cell(leavedays)="data">
                {{ data.item.leavedays }} days
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.staffmember.id,data.item.schoolterm.name,data.item.year,data.item.startdate,data.item.enddate,data.item.reason)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.staffmember.full_name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-leave" centered title="New Staff Time Off" title-class="font-18" hide-footer>
        <form @submit.prevent="addLeave">
          <div class="form-group mb-2">
            <label>Staff Member</label>
            <b-form-select v-model="staffmemberid" :options="staffmembers" class="mb-3 form-control" value-field="id" text-field="full_name"></b-form-select>
            </div>
            <div class="row">
              <div class="col-md-6">
              <label>Term</label>
              <v-select :options="schoolterms" placeholder="Select Term" v-model="schoolterm" label="name" :reduce="schoolterms => schoolterms.id"></v-select>
            </div>
            <div class="col-md-6">
              <label>Year</label>
            <b-form-input disabled v-model="year" type="number"></b-form-input>
            </div>
            </div>
            <div class="form-group mb-2">
            <label>Start Date</label>
            <input v-model="startdate" type="date" :min="currentdate" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>End Date</label>
            <input v-model="enddate" type="date" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Reason</label> 
            <textarea v-model="reason" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-leave')" >Close</b-button>
                <b-button type="submit" :disabled="btnuser" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-leave" centered title="Edit Staff Time Off" title-class="font-14" hide-footer>
        <form @submit.prevent="editLeave">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Staff Member</label>
            <b-form-select v-model="staffmemberid" :options="staffmembers" class="mb-3 form-control" value-field="id" text-field="full_name"></b-form-select>
            </div>
            <div class="row">
              <div class="col-md-6">
              <label>Term</label>
              <v-select disabled :options="schoolterms" placeholder="Select Term" v-model="schoolterm" label="name" :reduce="schoolterms => schoolterms.id"></v-select>
            </div>
            <div class="col-md-6">
              <label>Year</label>
            <b-form-input disabled v-model="year" type="number"></b-form-input>
            </div>
            </div>
            <div class="form-group mb-2">
            <label>Start Date</label>
            <input v-model="startdate" type="date"  :min="currentdate" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>End Date</label>
            <input v-model="enddate" type="date" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Reason</label> 
            <textarea v-model="reason" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-leave')" >Close</b-button>
                <b-button type="submit" :disabled="btnuser" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-leave" centered title="Delete Staff Time Off" title-class="font-18" hide-footer>
        <form @submit.prevent="removeLeave">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Leave : <b>{{ fullname }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-leave')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
  </div>  
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div>
  </div>

  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { staffleaveMethods, staffleaveComputed, staffmemberMethods, staffmemberComputed , schooltermComputed,schooltermMethods,} from "@/state/helpers";

export default {
  page: {
    title: "Staff Time Off",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Staff Time Off",
      items: [ {text: "Dashboard",to: "/",}, {text: "Staff Time Off",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'staffmember', label: 'Staff Member', visible: true },
          { key: 'schoolterm', label: 'Term', visible: true },
          { key: 'year', label: 'Year', visible: true },
          { key: 'startdate', label: 'Start Date', visible: true },
          { key: 'enddate', label: 'End Date', visible: true },
          { key: 'leavedays', label: 'Leave Days', visible: true },
          { key: 'reason', label: 'Reason', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      staffmember:'',staffmemberid:'',
      startdate:'',
      enddate:'',
      reason:'',name:'',
      fullname:'',schoolterm:'',year:new Date().getFullYear(),
      btnuser:false,
      currentdate:new Date().toLocaleDateString('fr-CA'),
    };
  },
  computed: {
    ...staffleaveComputed,
    ...staffmemberComputed,
    ...schooltermComputed,
    List() { return this.staffleaves.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.staffleaves.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.staffleaves.length>0) { a=false;} else { a=true;} return a }, 
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
  },
  mounted() {
    this.fetchStaffLeaves();
    this.fetchStaffMembers();
    this.fetchSchoolTerms();
    this.TotalRows = this.staffleaves.length;
    this.isBusy=false;
  },
  methods: {
    ...staffleaveMethods,
    ...staffmemberMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,staffmember,startdate,enddate,reason){
      this.id=id;
      this.staffmemberid=staffmember;
      this.startdate=startdate;
      this.enddate=enddate;
      this.reason=reason;
      this.$bvModal.show('edit-leave')
    },
    remove(id,fullname){
      this.id=id;
      this.fullname=fullname;
      this.$bvModal.show('delete-leave')
    },
    async addLeave() { 
      let formData = new FormData();
      formData.append("staffmemberid", this.staffmemberid);
      formData.append("schoolterm", this.schoolterm);
      formData.append("year", this.year);
      formData.append("startdate", this.startdate);
      formData.append("enddate", this.enddate);
      formData.append("reason", this.reason);
      let url = "/addstaffleave";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchStaffLeaves();
          this.$bvModal.hide('new-leave');
          this.staffmemberid="";
          this.startdate="";
          this.enddate="";
          this.reason="";
      }
      });
    },
    async editLeave(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("staffmemberid", this.staffmemberid);
    formData.append("startdate", this.startdate);
    formData.append("enddate", this.enddate);
    formData.append("reason", this.reason);
    let url = "/updatestaffleave";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchStaffLeaves();
        this.$bvModal.hide('edit-leave');
        this.staffmemberid="";
        this.startdate="";
        this.enddate="";
        this.reason="";
      }
    });
    },
    async removeLeave() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removestaffleave";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchStaffLeaves();
        this.$bvModal.hide('delete-leave');
      }
    });
    },
  },
};
</script>